import React from 'react';
import { NavLink } from 'react-router-dom';

const cleanName = (name) =>
  (name || '')
    .toLowerCase()
    .replace(' ', '')
    .replace('á', 'a')
    .replace('é', 'e')
    .replace('í', 'i')
    .replace('ó', 'o')
    .replace('ú', 'u');

const ThumbnailCard = ({ card, setSelectedCard, t }) => {
  const imageSrc = card.imageFront;
  if (!imageSrc) return null;

  return (
    <div className="column">
      <NavLink className="link postcard" to={`/card/${card._id}`}>
        <div className="postcard-thumbnail" onClick={() => setSelectedCard(card)}>
          <img src={imageSrc} alt={card.indicator} loading="lazy" />
        </div>
        <p className="postcard-data">
          <span className="bold">{card.indicator}</span>~{card.year}~
          {card.QTH ? `${card.QTH}~` : ''}
          {t(cleanName(card.country))}~{t(cleanName(card.continent))}
        </p>
      </NavLink>
    </div>
  );
};

export default ThumbnailCard;
